var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"postForm"},[_c('textarea',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.content},on:{"input":function($event){_vm.content = $event.target.value}}}),_vm._v(" "),_c('b-button',{staticClass:"button",attrs:{"variant":"info"},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }